module.exports = __webpack_public_path__ + "img/radioactive_hazard.84f46b00.svg";